import {Component, OnInit} from '@angular/core';
import {LoginService} from '../../../services/login.service';
import {AuthService} from '../../../auth/auth.service';
import {Market} from '../../../models/dealers/market.enum';
import {I18nProvider} from '../../../services/i18n.service';
import {I18nPipe} from "../../../services/i18n.pipe";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(private loginService: LoginService, private authService: AuthService,
              private i18nPipe: I18nPipe,
              private i8Provider: I18nProvider) {
  }

  user: string;
  readOnly: string;
  role: string;
  dealer: string;
  company: string;
  title = 'Digital Warranty Contract Platform';

  ngOnInit() {
    this.user = sessionStorage.getItem('user');
    this.role = sessionStorage.getItem('role');
    this.dealer = sessionStorage.getItem('dealer');
    this.company = sessionStorage.getItem('company');
    this.getLanguages();
    this.loginService.getEmitter().subscribe((res) => {
      if (res) {
        this.title = this.i18nPipe.transform('header-main-title', '');
        this.user = sessionStorage.getItem('user');
        this.role = sessionStorage.getItem('role');
        this.dealer = sessionStorage.getItem('dealer');
        this.company = sessionStorage.getItem('company');
      }
    });

  }

  showReport(): boolean{
    if (this.authService.market() === Market.NL) {
      return this.isAdmin();
    }
    return true;
  }

  isBEMarket() {
    return this.authService.market() === Market.BE;
  }

  isAdmin(): boolean{
    return this.authService.isAdmin();
  }

  isAuthenticated(): boolean{
    return this.authService.isAuthenticated();
  }

  private getLanguages() {
    if (this.isAuthenticated()) {
      this.i8Provider.load().then(r => this.i8Provider.langUpdated.emit(this.i8Provider.language));
    }
  }
}
